import './faq-stage.scss';
import autoComplete from 'pixabay-javascript-autocomplete';
import { getOffset, smoothScrollTo } from '../../../utilities/js/helper';
import axios from 'axios';

class FaqStage {
    constructor (element) {
        this.$faqStage = element;
        this.$inputWrapper = this.$faqStage.querySelector('[data-faq-stage="wrapper"]');
        this.$input = this.$faqStage.querySelector('[data-faq-stage="autocomplete"]');
        this.$form = this.$faqStage.querySelector('[data-form="root"]');
        this.url = this.$form.getAttribute('action');
    }

    initialize () {
        this.initAutocomplete();
    }

    initAutocomplete () {
        const CustomAutoComplete = autoComplete;

        axios({
            method: 'POST',
            url: this.url,
            data: new FormData(this.$form)
        })
            .then((result) => {
                const faqData = result.data;

                this.autocompleteField = new CustomAutoComplete({
                    selector: this.$input,
                    renderItem: (item, search) => {
                        search = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
                        const re = new RegExp('(' + search + ')', 'gi');
                        return '<div class="autocomplete-suggestion" data-question-id="' + item.id + '"><p>' + item.question.replace(re, '<strong>$1</strong>') + '</p></div>';
                    },
                    source: (term, suggest) => {
                        term = term.toLowerCase();
                        const matches = [];

                        for (let i = 0; i < faqData.length; i++) {
                            if (~faqData[i].question.toLowerCase().indexOf(term)) {
                                matches.push(faqData[i]);
                            } else {
                                if (~faqData[i].answer.toLowerCase().indexOf(term)) {
                                    matches.push(faqData[i]);
                                }
                            }
                        }
                        suggest(matches);
                    },
                    minChars: 2,
                    onSelect: (event, term, item) => {
                        const $item = item;
                        const entryId = $item.getAttribute('data-question-id');
                        const $entry = document.querySelector('[data-faq-section-question-id="' + entryId + '"]');

                        if ($entry) {
                            const themeId = $entry.closest('[data-faq-section-theme-id]').getAttribute('data-faq-section-theme-id');
                            const $theme = document.querySelector('[data-faq-section-theme-id="' + themeId + '"]');

                            if ($theme) {
                                $theme.click();

                                if (!$entry.parentElement.classList.contains('is--active')) {
                                    setTimeout(() => {
                                        $entry.click();
                                    }, 1000);
                                }

                                setTimeout(() => {
                                    const anchorDimensions = getOffset($entry);
                                    const anchorMovement = anchorDimensions.top;
                                    smoothScrollTo(0, anchorMovement, 1000);
                                }, 250);
                            }
                        }
                    }
                });
            })
            .catch((error) => {
                throw Error(error);
            });

        this.$form.addEventListener('submit', (e) => {
            e.preventDefault();
        });

        this.$input.addEventListener('focus', () => {
            if (this.$input.value !== '') {
                const value = this.$input.value;
                this.$input.value = '';
                this.$input.value = value;
            }
        });
    }
}

export { FaqStage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $faqStage = $context.querySelector('[data-faq-stage="root"]');

        if ($faqStage) {
            const $FaqStage = new FaqStage($faqStage);
            $FaqStage.initialize();
        }
    }
});
